export function handleNumberInput(input, allowEmpty = true) {
  // Allow only digits
  if (!/^\d*$/.test(input)) return "";

  // Allow empty string if desired
  if (input === "") return allowEmpty ? "" : "0";

  return input; // Let validation/clamping happen on blur
}
export function clampNumberInput(input, min, max) {
  const num = Number(input);

  if (isNaN(num)) return String(min);
  if (num < min) return String(min);
  if (num > max) return String(max);

  return String(num); // Remove any leading zeros too
}